import { Flex } from "@acko-tech/building-blocks.ui.common";
import {
  AppliedDiscountText,
  AppliedDiscountTextWrapper,
  ApplyDiscountButton,
  DiscountCardHeading,
  DiscountCardWrapper,
  DiscountImage,
  DiscountPara,
  DiscountTag,
  DiscountTagText,
  HeadingText,
  RenoveDiscountButton
} from "./styles";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { BasicLoader } from "@acko-tech/building-blocks.ui.loaders";
import { handleApplyDiscountAndUpdateProps } from "@actions/handleApplyDiscount";
import { useSelector } from "react-redux";
import { useOnload } from "@utils/useOnLoad";
import { connect } from "react-redux";
import { getWidgetSpecificProp } from "@utils/index";


interface DiscountCardProps {
  discountLogo: string;
  headingText: string;
  tagText: string;
  cardHeading: string;
  discountDesc: string;
  discountSecDesc?: string;
  applyDiscountLabel?: string;
  appliedDiscountText?: string;
  removeDiscountBtnLabel?: string;
  appliedImgSrc?: string;
  isSpecialDiscount?: boolean;
  isApplied?: boolean;
  actions: any;
  couponValue?: number,
  id: string;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    couponValue: getWidgetSpecificProp(
      state.configuration?.normalisedConfig,
      ownProps.id,
      "couponValue"
    )
  };
};

const DiscountCard = (props: DiscountCardProps) => {
  const {
    id,
    discountLogo,
    headingText,
    tagText,
    cardHeading,
    discountDesc,
    discountSecDesc,
    applyDiscountLabel,
    appliedDiscountText,
    removeDiscountBtnLabel,
    appliedImgSrc,
    isSpecialDiscount = false,
    isApplied = false,
    actions,
    couponValue

  } = props;
  const { on_click, onApplyDiscount, on_load, on_discount_success, on_discount_failure } = actions || {};
  const router = useRouter();
  const { proposal_ekey } = router.query;
  const [isLoading, setIsLoading] = useState(false);
  const [isUserApplied, setisUserApplied] = useState(false);

  const { selectedDiscount } = useSelector(({ globalState }: any) => {
    return {
      selectedDiscount: globalState?.selectedDiscount
    };
  });


  useOnload({ on_load });

  useEffect(() => {
    setisUserApplied(isApplied);
  }, []);

  useEffect(() => {
    if (!isSpecialDiscount && selectedDiscount) {
      setisUserApplied(selectedDiscount === tagText);
    }
  }, [selectedDiscount]);

  const handleApplyDiscount = async () => {
    if (on_click?.length > 0) {
      on_click?.forEach((eachFunc: any) => {
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall(eachFunc.args);
      });
    }

    await handleApplyDiscountAndUpdateProps(
      isUserApplied,
      setIsLoading,
      proposal_ekey,
      onApplyDiscount,
      setisUserApplied,
      "",
      on_discount_success,
      on_discount_failure,
      (e) => { },
      id
    );
  };

  return (
    <>
      {isLoading ? <BasicLoader /> : null}
      <DiscountCardWrapper>
        <Flex flexDirection="row" justifyContent="space-between">
          <DiscountImage src={discountLogo} />
          <HeadingText size="12px">{headingText}</HeadingText>
        </Flex>
        {tagText ? (
          <DiscountTag>
            <DiscountTagText>{tagText}</DiscountTagText>
          </DiscountTag>
        ) : null}
        {cardHeading ? (
          <DiscountCardHeading isSpecialDiscount={isSpecialDiscount}>{cardHeading}</DiscountCardHeading>
        ) : null}
        {discountDesc ? <DiscountPara>{discountDesc}</DiscountPara> : null}
        {discountSecDesc ? (
          <DiscountPara>{discountSecDesc}</DiscountPara>
        ) : null}
        {isUserApplied ? (
          <AppliedDiscountTextWrapper
            isSpecialDiscount={isSpecialDiscount}
          >
            <Flex alignItems="center">
              <img height={15} width={15} src={appliedImgSrc} />
              <AppliedDiscountText
              >{appliedDiscountText}{couponValue}</AppliedDiscountText>
            </Flex>
            <RenoveDiscountButton size="medium" onClick={handleApplyDiscount}>
              {removeDiscountBtnLabel}
            </RenoveDiscountButton>
          </AppliedDiscountTextWrapper>
        ) : (
          <ApplyDiscountButton size="medium" onClick={handleApplyDiscount}>
            {applyDiscountLabel}
          </ApplyDiscountButton>
        )}
      </DiscountCardWrapper>
    </>
  );
};
export default connect(mapStateToProps)(DiscountCard);
